(() => {
  'use strict';

  const root = document.querySelector('[data-trust-florame]');
  if (!root || root.dataset.tfReady === '1') return;
  root.dataset.tfReady = '1';

  const API_BASE = String(root.dataset.apiBase || '').replace(/\/$/, '');
  const TOKEN_KEY = 'florame_trust_author_v1';
  const TAG_LABELS = {
    creazione: 'Creazione',
    chiarezza: 'Chiarezza',
    qualita: 'Qualità',
    consegna: 'Consegna',
    assistenza: 'Assistenza',
    regalo: 'Regalo'
  };
  const ERROR_COPY = {
    EMAIL_INVALID: 'Controlla l’indirizzo email.',
    EMAIL_VERIFICATION_RATE_LIMITED: 'Hai appena richiesto un codice. Attendi un minuto.',
    VERIFICATION_CODE_INVALID: 'Il codice non è corretto.',
    VERIFICATION_REQUEST_EXPIRED: 'Il codice è scaduto. Richiedine uno nuovo.',
    VERIFICATION_ATTEMPTS_EXCEEDED: 'Troppi tentativi. Richiedi un nuovo codice.',
    TRUST_REVIEW_COOLDOWN: 'Con questa email è già stata pubblicata una recensione recente.',
    RATING_INVALID: 'Scegli da una a cinque stelle.',
    TITLE_TOO_SHORT: 'Scrivi un titolo un po’ più chiaro.',
    REVIEW_TOO_SHORT: 'Raccontaci qualcosa in più: bastano almeno 20 caratteri.',
    MEDIA_TOO_LARGE: 'Il file è troppo grande.',
    MEDIA_TYPE_INVALID: 'Questo formato non è supportato.',
    MEDIA_LIMIT_REACHED: 'Puoi allegare al massimo quattro file.',
    VIDEO_LIMIT_REACHED: 'Puoi allegare un solo video.',
    TRUST_REVIEW_EDIT_EXPIRED: 'Il periodo di modifica di sette giorni è terminato.',
    RATE_LIMITED: 'Troppe richieste ravvicinate. Riprova tra qualche minuto.'
  };

  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const state = {
    token: localStorage.getItem(TOKEN_KEY) || '',
    requestId: '',
    rating: null,
    verifiedOnly: false,
    cursor: '',
    hasMore: false,
    reviews: [],
    aggregate: null,
    publishedCount: 0,
    mine: null,
    media: [],
    loading: false
  };

  async function api(path, { method = 'GET', body, headers = {} } = {}) {
    const response = await fetch(`${API_BASE}/${path}`, {
      method,
      mode: 'cors',
      credentials: 'omit',
      headers: body instanceof Blob ? headers : { 'Content-Type': 'application/json', ...headers },
      body: body == null ? undefined : body instanceof Blob ? body : JSON.stringify(body)
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.success === false) {
      const error = new Error(ERROR_COPY[payload.error] || 'Non siamo riusciti a completare l’operazione. Riprova.');
      error.code = payload.error || `HTTP_${response.status}`;
      throw error;
    }
    return payload;
  }

  function stars(rating) {
    const rounded = Math.max(0, Math.min(5, Math.round(Number(rating || 0))));
    return Array.from({ length: 5 }, (_, index) => `<svg viewBox="0 0 24 24" aria-hidden="true" style="opacity:${index < rounded ? 1 : .2}"><path d="m12 2.8 2.8 5.7 6.3.9-4.6 4.5 1.1 6.3-5.6-3-5.6 3 1.1-6.3-4.6-4.5 6.3-.9L12 2.8Z"></path></svg>`).join('');
  }

  function formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
  }

  function showNotice(message, tone = 'success') {
    const notice = $('[data-tf-notice]');
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = !message;
    notice.style.color = tone === 'error' ? '#9f2448' : '';
    notice.style.background = tone === 'error' ? '#fff0f4' : '';
  }

  function renderScore() {
    const aggregate = state.aggregate || { average: 0, count: 0, distribution: {} };
    const verifiedCount = Number(aggregate.count || 0);
    const publishedCount = Number(state.publishedCount || verifiedCount);
    const scoreCard = $('[data-tf-score-card]');
    const skeleton = $('.tf-score-skeleton', scoreCard);
    const content = $('.tf-score-content', scoreCard);
    skeleton.hidden = true;
    content.hidden = false;
    const average = Number(aggregate.average || 0);
    $('[data-tf-average]').textContent = aggregate.count ? average.toFixed(1).replace('.', ',') : '—';
    const starNode = $('[data-tf-stars]');
    starNode.innerHTML = stars(average);
    starNode.setAttribute('aria-label', aggregate.count ? `${average.toFixed(1)} stelle su 5` : 'Nessuna valutazione');
    $('[data-tf-count]').textContent = verifiedCount
      ? `Basato su ${verifiedCount} ${verifiedCount === 1 ? 'esperienza verificata' : 'esperienze verificate'}`
      : 'La prima esperienza può essere la tua.';
    $('[data-tf-filter-total]').textContent = `${publishedCount} ${publishedCount === 1 ? 'recensione pubblicata' : 'recensioni pubblicate'}`;
    renderDistribution();
  }

  function renderDistribution() {
    const aggregate = state.aggregate || { count: 0, distribution: {} };
    const container = $('[data-tf-distribution]');
    const total = Number(aggregate.count || 0);
    container.innerHTML = [5, 4, 3, 2, 1].map((rating) => {
      const count = Number(aggregate.distribution?.[String(rating)] || 0);
      const percent = total ? Math.round((count / total) * 100) : 0;
      return `<button type="button" data-tf-rating-filter="${rating}" class="${state.rating === rating ? 'is-active' : ''}" aria-pressed="${state.rating === rating}"><span>${rating} ★</span><i aria-hidden="true"><span style="width:${percent}%"></span></i><small>${count}</small></button>`;
    }).join('');
    $('[data-tf-reset]').hidden = !state.rating && !state.verifiedOnly;
  }

  function renderMedia(media = []) {
    if (!media.length) return '';
    return `<div class="tf-review-media">${media.map((item) => item.type === 'video'
      ? `<video controls preload="metadata" playsinline aria-label="${escapeHtml(item.alt || 'Video della recensione')}"><source src="${escapeHtml(item.url)}"></video>`
      : `<img src="${escapeHtml(item.url)}" alt="${escapeHtml(item.alt || 'Foto della recensione')}" loading="lazy" decoding="async">`).join('')}</div>`;
  }

  function renderReview(review) {
    const verified = review.verification?.purchaseVerified === true;
    const tags = Array.isArray(review.tags) ? review.tags.filter((tag) => TAG_LABELS[tag]) : [];
    const product = review.commerce?.product;
    const verificationLabel = review.legacy?.label || (verified ? 'Acquisto verificato' : 'Email verificata');
    const productLink = product?.url ? `<a class="tf-review-product" href="${escapeHtml(product.url)}"><span>${product.imageUrl ? `<img src="${escapeHtml(product.imageUrl)}" alt="" loading="lazy">` : '↗'}</span><span><small>Prodotto Shopify</small><strong>${escapeHtml(product.title || 'Apri il prodotto')}</strong></span></a>` : '';
    return `<article class="tf-review-card" data-review-id="${escapeHtml(review.id)}">
      <div class="tf-review-card-head"><div class="tf-review-rating" aria-label="${Number(review.rating || 0)} stelle">${stars(review.rating)}</div><time class="tf-review-date" datetime="${escapeHtml(review.publishedAt || review.submittedAt || '')}">${escapeHtml(formatDate(review.publishedAt || review.submittedAt))}</time></div>
      <h3>${escapeHtml(review.title)}</h3>
      <p>${escapeHtml(review.body)}</p>
      ${productLink}
      ${renderMedia(review.media)}
      ${tags.length ? `<div class="tf-review-tags">${tags.map((tag) => `<span>${escapeHtml(TAG_LABELS[tag])}</span>`).join('')}</div>` : ''}
      <div class="tf-review-meta"><strong>${escapeHtml(review.publicName || 'Cliente Florame')}</strong>${review.city ? `<small>${escapeHtml(review.city)}</small>` : ''}<span class="tf-review-badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 20 7v5c0 5-3.4 8.4-8 9.7C7.4 20.4 4 17 4 12V7l8-4Z"></path><path d="m8.5 12 2.2 2.2 4.8-5"></path></svg>${escapeHtml(verificationLabel)}</span></div>
      ${review.florameResponse?.body ? `<div class="tf-florame-response"><strong>Risposta di Florame</strong><p>${escapeHtml(review.florameResponse.body)}</p></div>` : ''}
      <div class="tf-review-footer"><button class="tf-report-toggle" type="button" data-tf-report-toggle>Segnala contenuto</button></div>
      <div class="tf-report-choices" hidden><button type="button" data-tf-report="privacy">Dati personali</button><button type="button" data-tf-report="spam">Spam</button><button type="button" data-tf-report="abuse">Abuso</button><button type="button" data-tf-report="not_genuine">Non autentica</button></div>
    </article>`;
  }

  function renderFeed({ append = false } = {}) {
    const list = $('[data-tf-list]');
    if (!state.reviews.length) {
      list.innerHTML = `<div class="tf-empty"><strong>${state.rating || state.verifiedOnly ? 'Nessuna corrispondenza, per ora.' : 'Uno spazio nuovo, senza recensioni inventate.'}</strong><p>${state.rating || state.verifiedOnly ? 'Azzera i filtri per leggere tutte le esperienze.' : 'Quando arriverà la prima esperienza verificata, comparirà qui.'}</p><button class="tf-button tf-button-primary" type="button" data-tf-open>Scrivi la prima recensione</button></div>`;
    } else {
      const html = state.reviews.map(renderReview).join('');
      list.innerHTML = append ? list.innerHTML + html : html;
    }
    $('[data-tf-more]').hidden = !state.hasMore;
  }

  async function loadReviews({ append = false } = {}) {
    if (state.loading) return;
    state.loading = true;
    const more = $('[data-tf-more]');
    if (more) more.disabled = true;
    try {
      const params = new URLSearchParams({ limit: '12' });
      if (append && state.cursor) params.set('cursor', state.cursor);
      if (state.rating) params.set('rating', String(state.rating));
      if (state.verifiedOnly) params.set('verified', 'true');
      const payload = await api(`trustFloramePublicListV1?${params.toString()}`);
      state.aggregate = payload.aggregate || state.aggregate;
      state.publishedCount = Number(payload.publishedCount || state.aggregate?.count || 0);
      state.reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
      state.cursor = payload.nextCursor || '';
      state.hasMore = payload.hasMore === true;
      renderScore();
      renderFeed({ append });
    } catch (error) {
      showNotice(error.message, 'error');
      if (!append) {
        $('[data-tf-list]').innerHTML = '<div class="tf-empty"><strong>Qui dovrebbe esserci una conversazione.</strong><p>Il caricamento non è riuscito. Riprova tra poco.</p><button class="tf-button tf-button-light" type="button" data-tf-retry>Riprova</button></div>';
      }
    } finally {
      state.loading = false;
      if (more) more.disabled = false;
    }
  }

  function setStep(name) {
    $$('[data-tf-step]').forEach((step) => { step.hidden = step.dataset.tfStep !== name; });
  }

  function openDialog() {
    const dialog = $('[data-tf-dialog]');
    setFormError('');
    if (!dialog.open) dialog.showModal();
    if (state.token) {
      setStep('review');
      loadMine();
    } else {
      setStep('email');
    }
  }

  function closeDialog() {
    const dialog = $('[data-tf-dialog]');
    if (dialog.open) dialog.close();
  }

  function setFormError(message = '') {
    const node = $('[data-tf-form-error]');
    node.textContent = message;
    node.hidden = !message;
  }

  function setButtonLoading(button, loading, label = 'Attendi…') {
    if (!button) return;
    if (loading) {
      if (!button.dataset.tfIdleHtml) button.dataset.tfIdleHtml = button.innerHTML;
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      const spinner = document.createElement('span');
      spinner.className = 'tf-button-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span');
      copy.textContent = label;
      button.replaceChildren(spinner, copy);
      return;
    }
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    if (button.dataset.tfIdleHtml) {
      button.innerHTML = button.dataset.tfIdleHtml;
      delete button.dataset.tfIdleHtml;
    }
    button.disabled = false;
  }

  function selectRating(value) {
    const form = $('[data-tf-review-form]');
    form.elements.rating.value = value || '';
    $$('[data-rating]', form).forEach((button) => button.classList.toggle('is-active', Number(button.dataset.rating) <= Number(value || 0)));
  }

  function resetComposer() {
    const form = $('[data-tf-review-form]');
    form.reset();
    selectRating(0);
    state.media.forEach((item) => { if (item.previewUrl?.startsWith('blob:')) URL.revokeObjectURL(item.previewUrl); });
    state.media = [];
    state.mine = null;
    renderMediaPreview();
    $('[data-tf-withdraw]').hidden = true;
    const submit = $('.tf-review-form .tf-button-primary');
    submit.textContent = 'Pubblica la recensione';
    submit.disabled = false;
  }

  function fillMine(review) {
    if (!review) return;
    const form = $('[data-tf-review-form]');
    state.mine = review;
    form.elements.publicName.value = review.publicName || '';
    form.elements.city.value = review.city || '';
    form.elements.title.value = review.title || '';
    form.elements.body.value = review.body || '';
    selectRating(review.rating || 0);
    $$('input[name="tags"]', form).forEach((input) => { input.checked = Array.isArray(review.tags) && review.tags.includes(input.value); });
    state.media = Array.isArray(review.media) ? review.media.map((item) => ({ ...item, previewUrl: item.url, uploaded: true })) : [];
    renderMediaPreview();
    $('[data-tf-withdraw]').hidden = review.canEdit !== true;
    $('.tf-review-form .tf-button-primary').textContent = review.canEdit ? 'Salva le modifiche' : 'Periodo di modifica terminato';
    $('.tf-review-form .tf-button-primary').disabled = review.canEdit === false;
  }

  async function loadMine() {
    if (!state.token) return;
    try {
      const payload = await api('trustFloramePublicV1', { method: 'POST', body: { action: 'mine', token: state.token } });
      if (payload.review) fillMine(payload.review);
      else resetComposer();
    } catch (error) {
      if (['TRUST_SESSION_NOT_FOUND', 'TRUST_SESSION_EXPIRED'].includes(error.code)) {
        localStorage.removeItem(TOKEN_KEY);
        state.token = '';
        resetComposer();
        setStep('email');
      } else setFormError(error.message);
    }
  }

  function renderMediaPreview() {
    const container = $('[data-tf-media-preview]');
    container.innerHTML = state.media.map((item, index) => `<figure data-media-index="${index}">${item.type === 'video' || item.file?.type?.startsWith('video/')
      ? `<video src="${escapeHtml(item.previewUrl || '')}" muted playsinline></video>`
      : `<img src="${escapeHtml(item.previewUrl || '')}" alt="Anteprima allegato">`}<button type="button" aria-label="Rimuovi allegato" data-tf-remove-media="${index}">×</button>${item.uploading ? '<progress></progress>' : ''}</figure>`).join('');
  }

  async function uploadFiles(files) {
    const accepted = Array.from(files || []).slice(0, 4 - state.media.length);
    const videoAlready = state.media.some((item) => item.type === 'video' || item.file?.type?.startsWith('video/'));
    for (const file of accepted) {
      const isVideo = file.type.startsWith('video/');
      if (isVideo && (videoAlready || state.media.some((item) => item.type === 'video'))) {
        setFormError(ERROR_COPY.VIDEO_LIMIT_REACHED);
        continue;
      }
      const limit = isVideo ? 24 * 1024 * 1024 : 10 * 1024 * 1024;
      if (file.size > limit) {
        setFormError(ERROR_COPY.MEDIA_TOO_LARGE);
        continue;
      }
      const entry = { file, type: isVideo ? 'video' : 'image', previewUrl: URL.createObjectURL(file), uploading: true };
      state.media.push(entry);
      renderMediaPreview();
      try {
        const payload = await api('trustFlorameMediaUploadV1', {
          method: 'POST',
          body: file,
          headers: { 'Content-Type': file.type || 'application/octet-stream', 'X-Trust-Token': state.token, 'X-File-Name': file.name || 'media' }
        });
        Object.assign(entry, payload.media, { uploaded: true, uploading: false });
      } catch (error) {
        const index = state.media.indexOf(entry);
        if (index >= 0) state.media.splice(index, 1);
        URL.revokeObjectURL(entry.previewUrl);
        setFormError(error.message);
      }
      renderMediaPreview();
    }
  }

  async function authorizeInvite(inviteToken) {
    try {
      const payload = await api('trustFloramePublicV1', { method: 'POST', body: { action: 'authorize_invite', inviteToken } });
      state.token = payload.token;
      localStorage.setItem(TOKEN_KEY, state.token);
      const url = new URL(location.href);
      url.hash = '';
      url.searchParams.set('write', '1');
      history.replaceState({}, '', url.toString());
      openDialog();
      showNotice('Ordine riconosciuto: la recensione avrà il badge “Acquisto verificato”.');
    } catch (error) {
      showNotice('Il vecchio invito non è più utilizzabile. Puoi comunque verificare la tua email.', 'error');
      openDialog();
    }
  }

  root.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-tf-open]');
    if (open) { event.preventDefault(); openDialog(); return; }
    if (event.target.closest('[data-tf-close]')) { closeDialog(); return; }
    if (event.target.closest('[data-tf-done]')) { closeDialog(); document.querySelector('.tf-reviews-layout')?.scrollIntoView({ behavior: 'smooth' }); return; }
    if (event.target.closest('[data-tf-retry]')) { loadReviews(); return; }
    const ratingFilter = event.target.closest('[data-tf-rating-filter]');
    if (ratingFilter) {
      const value = Number(ratingFilter.dataset.tfRatingFilter);
      state.rating = state.rating === value ? null : value;
      state.cursor = '';
      loadReviews();
      return;
    }
    if (event.target.closest('[data-tf-reset]')) {
      state.rating = null;
      state.verifiedOnly = false;
      $('[data-tf-verified-filter]').checked = false;
      state.cursor = '';
      loadReviews();
      return;
    }
    const ratingButton = event.target.closest('[data-rating]');
    if (ratingButton) { selectRating(Number(ratingButton.dataset.rating)); return; }
    const removeMedia = event.target.closest('[data-tf-remove-media]');
    if (removeMedia) {
      const index = Number(removeMedia.dataset.tfRemoveMedia);
      const [item] = state.media.splice(index, 1);
      if (item?.previewUrl?.startsWith('blob:')) URL.revokeObjectURL(item.previewUrl);
      renderMediaPreview();
      return;
    }
    const reportToggle = event.target.closest('[data-tf-report-toggle]');
    if (reportToggle) {
      const choices = $('.tf-report-choices', reportToggle.closest('.tf-review-card'));
      choices.hidden = !choices.hidden;
      return;
    }
    const reportButton = event.target.closest('[data-tf-report]');
    if (reportButton) {
      const card = reportButton.closest('[data-review-id]');
      reportButton.disabled = true;
      try {
        await api('trustFloramePublicV1', { method: 'POST', body: { action: 'report', reviewId: card.dataset.reviewId, reason: reportButton.dataset.tfReport } });
        $('.tf-report-choices', card).innerHTML = '<small>Grazie, la segnalazione è stata inviata.</small>';
      } catch (error) { showNotice(error.message, 'error'); }
      return;
    }
    if (event.target.closest('[data-tf-more]')) loadReviews({ append: true });
  });

  $('[data-tf-verified-filter]').addEventListener('change', (event) => {
    state.verifiedOnly = event.target.checked;
    state.cursor = '';
    loadReviews();
  });

  $('[data-tf-dialog]').addEventListener('click', (event) => {
    if (event.target === event.currentTarget) closeDialog();
  });

  $('[data-tf-email-form]').addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = event.currentTarget.querySelector('button');
    setButtonLoading(button, true, 'Invio codice…');
    try {
      const payload = await api('trustFloramePublicV1', { method: 'POST', body: { action: 'start', email: event.currentTarget.elements.email.value } });
      state.requestId = payload.requestId;
      setStep('code');
      $('[data-tf-code-form] input').focus();
    } catch (error) { setFormError(error.message); }
    finally { setButtonLoading(button, false); }
  });

  $('[data-tf-code-form]').addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = event.currentTarget.querySelector('button');
    setButtonLoading(button, true, 'Verifica…');
    try {
      const payload = await api('trustFloramePublicV1', { method: 'POST', body: { action: 'verify', requestId: state.requestId, code: event.currentTarget.elements.code.value } });
      state.token = payload.token;
      localStorage.setItem(TOKEN_KEY, state.token);
      resetComposer();
      setStep('review');
    } catch (error) { setFormError(error.message); }
    finally { setButtonLoading(button, false); }
  });

  $('[data-tf-media]').addEventListener('change', (event) => {
    setFormError('');
    uploadFiles(event.target.files);
    event.target.value = '';
  });

  $('[data-tf-review-form]').addEventListener('submit', async (event) => {
    event.preventDefault();
    setFormError('');
    if (state.media.some((item) => item.uploading)) { setFormError('Attendi il caricamento degli allegati.'); return; }
    const form = event.currentTarget;
    if (!form.elements.rating.value) {
      setFormError('Scegli da una a cinque stelle.');
      $('[data-rating="1"]', form)?.focus();
      return;
    }
    const button = form.querySelector('.tf-button-primary');
    setButtonLoading(button, true, state.mine ? 'Salvataggio…' : 'Pubblicazione…');
    try {
      const payload = await api('trustFloramePublicV1', {
        method: 'POST',
        body: {
          action: state.mine ? 'update' : 'submit',
          token: state.token,
          rating: Number(form.elements.rating.value),
          publicName: form.elements.publicName.value,
          city: form.elements.city.value,
          title: form.elements.title.value,
          body: form.elements.body.value,
          tags: $$('input[name="tags"]:checked', form).map((input) => input.value),
          mediaIds: state.media.filter((item) => item.uploaded).map((item) => item.id)
        }
      });
      state.mine = payload.review;
      $('[data-tf-success-copy]').textContent = payload.review?.publishedAt
        ? 'La recensione è online. Potrai correggerla per sette giorni.'
        : 'La recensione è al sicuro e verrà pubblicata dopo il controllo privacy.';
      setStep('success');
      state.cursor = '';
      await loadReviews();
    } catch (error) { setFormError(error.message); }
    finally { setButtonLoading(button, false); }
  });

  $('[data-tf-withdraw]').addEventListener('click', async () => {
    if (!window.confirm('Vuoi ritirare la recensione? Non sarà più visibile.')) return;
    const button = $('[data-tf-withdraw]');
    setButtonLoading(button, true, 'Ritiro…');
    try {
      await api('trustFloramePublicV1', { method: 'POST', body: { action: 'withdraw', token: state.token } });
      resetComposer();
      setStep('success');
      $('[data-tf-success-copy]').textContent = 'La recensione è stata ritirata e gli allegati sono stati rimossi.';
      await loadReviews();
    } catch (error) { setFormError(error.message); }
    finally { setButtonLoading(button, false); }
  });

  const params = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(String(location.hash || '').replace(/^#/, ''));
  loadReviews();
  if (hashParams.get('invite')) authorizeInvite(hashParams.get('invite'));
  else if (params.get('write') === '1' || root.dataset.openComposer === 'true') openDialog();
})();
